import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PageBreadcrumb from "components/common/PageBreadcrumb";

interface MetaHeaderProps {
  breadcrumbItems: Array<{
    label: string;
    url?: string;
    active?: boolean;
  }>;
}

export const MetaHeader: React.FC<MetaHeaderProps> = ({ breadcrumbItems }) => {
  return (
    <div className="bg-gradient-primary text-white py-4 mb-4 header-animated">
      <Container>
        <Row className="align-items-center">
          <Col>
            <PageBreadcrumb
              items={breadcrumbItems}
              className="mb-2 text-white-50"
            />
            <div className="d-flex flex-wrap gap-3 flex-between-end">
              <div>
                <h2 className="mb-2">Controle de Metas</h2>
                <h5 className="text-body-tertiary fw-semibold">
                  Acompanhe o desempenho da equipe de vendas em tempo real
                </h5>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
